import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'

export const ProductDiscount: FC<ComponentProps<'span'>> = ({
  children,
  className,
  ...rest
}) => (
  <span
    className={clsx(
      'flex min-w-12 items-center justify-center rounded-full bg-light-tertiary p-1 font-mono text-dark-primary-max',
      className,
    )}
    {...rest}
  >
    {children}
  </span>
)
